<template>
  <footer class="footer">
    <div class="footer__top">
      <div class="container">
        <div class="footer__grid">
          <!-- Brand -->
          <div class="footer__brand">
            <router-link to="/" class="footer__logo">
              <img :src="logoImg" alt="GELT" class="footer__logo-img">
            </router-link>
            <p class="footer__tagline">Connect Legal Talents Everywhere
              Reach Legal Minds Across Borders
            </p>
            <!-- <p class="footer__desc">
              A premier global network of independent law firms, delivering exceptional 
              legal services across borders since 1989.
            </p> -->
          </div>

          <!-- Quick Links -->
          <div class="footer__nav">
            <h4>About</h4>
            <ul>
              <li><router-link to="/about">Intro to GELT</router-link></li>
              <li><router-link to="/about/why-law">Why GELT?</router-link></li>
              <!-- <li><router-link to="/about/governance">Governance</router-link></li>
              <li><router-link to="/about/emerging-leaders">Emerging Leaders</router-link></li> -->
            </ul>
          </div>

          <!-- <div class="footer__nav">
            <h4>Network</h4>
            <ul>
              <li><router-link to="/find-a-firm">Find a Firm</router-link></li>
              <li><router-link to="/member-directory">Member Directory</router-link></li>
              <li><router-link to="/practice-groups">Practice Groups</router-link></li>
              <li><router-link to="/meetings">Meetings</router-link></li>
            </ul>
          </div>

          <div class="footer__nav">
            <h4>Membership</h4>
            <ul>
              <li><router-link to="/join-law">Learn About LAW</router-link></li>
              <li><router-link to="/join-law/membership-criteria">Membership Criteria</router-link></li>
              <li><router-link to="/join-law/membership-benefits">Benefits</router-link></li>
              <li><router-link to="/join-law/request-info">Request Information</router-link></li>
            </ul>
          </div> -->

          <div class="footer__nav">
            <h4>Connect</h4>
            <ul>
              <li><router-link to="/news">Events</router-link></li>
              <li><router-link to="/contact">Contact Us</router-link></li>
              <li><router-link to="/login">Member Login</router-link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="footer__bottom">
      <div class="container">
        <div class="footer__bottom-content">
          <p>&copy; {{ currentYear }} Global Alliance of Emerging Legal Talents. All rights reserved.</p>
          <div class="footer__legal">
            <!-- <router-link to="/terms">Terms of Use</router-link>
            <span class="separator">|</span> -->
            <router-link to="/privacy">Privacy Policy</router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'
import logoImg from '@/assets/logo-footer.png'

export default {
  name: 'AppFooter',
  setup() {
    const currentYear = computed(() => new Date().getFullYear())
    return { currentYear, logoImg }
  }
}
</script>

<style scoped>
.footer {
  background: linear-gradient(180deg, #050810 0%, #030508 100%);
  color: var(--white);
}

.footer__top {
  padding: 5rem 0 4rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.footer__grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  gap: 3rem;
}

/* Brand */
.footer__logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-bottom: 1rem;
}

.footer__logo-img {
  height: 2.2rem;
  width: auto;
  display: block;
}

.footer__tagline {
  font-family: var(--font-display);
  font-style: italic;
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.1rem;
  margin-bottom: 1rem;
}

.footer__desc {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.8;
  margin: 0;
  max-width: 280px;
}

/* Navigation */
.footer__nav h4 {
  font-family: var(--font-family);
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: var(--accent);
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.footer__nav ul {
  list-style: none;
}

.footer__nav li {
  margin-bottom: 0.75rem;
}

.footer__nav a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  position: relative;
}

.footer__nav a::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 0;
  height: 1px;
  background: var(--accent);
  transition: width 0.3s ease;
}

.footer__nav a:hover {
  color: var(--white);
}

.footer__nav a:hover::before {
  width: 100%;
}

/* Bottom */
.footer__bottom {
  padding: 1.5rem 0;
}

.footer__bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.4);
}

.footer__legal {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.separator {
  opacity: 0.3;
}

.footer__legal a {
  color: rgba(255, 255, 255, 0.4);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer__legal a:hover {
  color: var(--accent);
}

@media (max-width: 1024px) {
  .footer__grid {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .footer__brand {
    grid-column: 1 / -1;
    margin-bottom: 1rem;
    max-width: 100%;
  }
  
  .footer__desc {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
  .footer__grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .footer__bottom-content {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
}
</style>
